import React from 'react';
import {connect} from 'react-redux';
import {filterAccounts,clearAccountFilter} from '../store/teachActions';
import isValidRe from './isValidRe';

const TeachAccountFilter = ({filterAccounts,clearAccountFilter}) => {
  const onChange = (e) => {
    if(e.target.value!=='' && isValidRe(e.target.value)){
      filterAccounts(e.target.value);
    } else {
      clearAccountFilter();
    }
  };

  return (
    <div className='row container'>
      <br />
      <form className='col s12' onSubmit={e=>e.preventDefault()}>
        <input type='text' placeholder='Regex Filter (course, shell, email, gidNumber)'
        onChange={onChange} />
      </form>
    </div>
  );
};

export default connect(null,{filterAccounts,clearAccountFilter})(TeachAccountFilter);
